module.exports = {"width":1916,"height":1278,"type":"png"}